(function ($) {
    'use strict';
    $(function () {

        const heroSwiper = new Swiper('.js-hero-swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
                el: ".js-hero-swiper-pagination",
                clickable: true
            },
            autoHeight: true
            /*  autoplay: {
                 delay: 3000,
                 pauseOnMouseEnter: true,
                 disableOnInteraction: false
             }, */

        });



    });
})(jQuery);